<template>

<!-- Main -->
<div id="main">

  <b-pagination-nav
    class="text-center"
    :number-of-pages="searchResults.pages"
    :pages="pagination"
    use-router
    align="center"
    :first-text="'«'"
    :prev-text="'‹'"
    :next-text="'›'"
    :last-text="'»'"
  ></b-pagination-nav>

  <h2 class="search-result-header">
    Результаты поиска «<span>{{this.$route.query.q}}</span>»
    (<span>{{searchResults.count}}</span> записи найдено)
  </h2>

  <section class="results-list">
    <template v-if="searchResults.results && searchResults.results.length !== 0">
      <ol>
        <li v-for="row in searchResults.results" v-bind:key="row.id">
          <router-link
            :to="{ name: 'SinglePage', params: { uri: row.uri }}"
          >
            {{$options.filters.moment(row.creation_date, 'YYYY-MM-DD')}} /
            {{row.structure.title}} /
            <span>{{row.title}}</span>
          </router-link>
          <br>
          <span>{{row.seo_description}}</span>
        </li>
      </ol>
    </template>
    <template v-else>
      К сожалению по Вашему запросу ничего не найдено!
    </template>
  </section>

  <b-pagination-nav
    class="text-center"
    :number-of-pages="searchResults.pages"
    :pages="pagination"
    use-router
    align="center"
    :first-text="'«'"
    :prev-text="'‹'"
    :next-text="'›'"
    :last-text="'»'"
  ></b-pagination-nav>

</div>

</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SearchResult',
  data() {
    return {
      pagination: [],
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
  },
  computed: mapState({
    searchResults: state => state.searchResults,
  }),
  components: {

  },
  methods: {
    fetchData() {
      if (this.$route.name === 'SearchResult') {
        this.$store.dispatch('loadSearchResult',
          {
            start: this.$route.query.start,
            limit: this.$route.query.limit,
            q: this.$route.query.q,
          });
      }
    },
  },
  watch: {
    $route: 'fetchData',
    searchResults: function paginationHandler(searchResults) {
      this.pagination = [];
      for (let i = 0; i < searchResults.pages; i += 1) {
        this.pagination.push({
          link: {
            query: {
              start: (i * 20) + 1,
              limit: 20,
              q: this.$route.query.q,
            },
          },
          text: i + 1,
        });
      }
    },
  },
};
</script>
